import type { SimplePaletteColorOptions } from '@mui/material';

export const STATE_COLOR_NAMES = [
  'pending',
  'done',
  'cancelled',
  'default',
] as const;

export type StateColorName = (typeof STATE_COLOR_NAMES)[number];

type StateColors = Record<StateColorName, SimplePaletteColorOptions>;

export const stateColors: StateColors = {
  pending: { main: '#0065adff' },
  done: { main: '#3b6302ff' },
  cancelled: { main: '#6a151eff' },
  default: { main: '#494c57ff' },
};

export const darkStateColors: StateColors = {
  pending: { main: '#E6EC9E' },
  done: { main: '#C5F28A' },
  cancelled: { main: '#F5C2C5' },
  default: { main: '#C3C7CC' },
};
